import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CrewMerchantUi } from 'corso-types';
import api from '~/api';
import {
  shippingClaimQueryKey,
  useShippingClaim,
} from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export function useShippingClaimLineItemAdd() {
  const storeId = useStoreId();
  const shippingClaim = useShippingClaim();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CrewMerchantUi.ShippingClaimLineItemAdd) =>
      api
        .store(storeId)
        .shippingProtection.claim(`${shippingClaim.id}`)
        .lineItem.add(body),
    // the inventory modal reads its own query, so it goes stale on any line item change
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: shippingClaimQueryKey(shippingClaim.id, storeId),
      });
      await queryClient.invalidateQueries({
        queryKey: ['shippingClaimInventoryLevels', shippingClaim.id, storeId],
      });
    },
  });
}
